
	import { Component, Vue } from 'vue-property-decorator';
	import IResource from "@/IResource";

	@Component({
		components: {},
	})
	export default class ResourceimageGallery extends Vue {

		public selectedImage: number = 0;

		get resource(): IResource {
			return this.$store.state.resource;
		}

		public showNext() {
			this.selectedImage = (this.selectedImage + 1) % this.resource.resourceimages.length;
		}

		public showPrev() {
			this.selectedImage = (this.selectedImage - 1) % this.resource.resourceimages.length;
			if (this.selectedImage < 0) {
				this.selectedImage = this.resource.resourceimages.length - 1;
			}
		}
	}
